import { useGetMe } from '@shared/services/get-me';
import { useGetSubscription } from '@shared/services/get-subscription';

const useCheckSubscription = () => {
  const { data: member } = useGetMe();
  const { data: subscription } = useGetSubscription();

  return {
    isFreeTrial:
      !member?.organization?.trial_plan_completed &&
      subscription?.status === 'NONE',
    isTrialCompleted:
      member?.organization?.trial_plan_completed && subscription?.is_expired,
    subscription,
    member,
  };
};

export default useCheckSubscription;
